import React from 'react';
import PropTypes from 'prop-types';

const ErrorMessage = props => (
  <div class="ui basic text container negative message">
    <div class="header">Error</div>
    <p>{props.message}</p>
  </div>
);

ErrorMessage.propTypes = {
  message: PropTypes.string.isRequired
};

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/components/ErrorMessagePretty.js